module.exports = __webpack_public_path__ + "static/media/research-techniques-bg-2.7f7bfd95.svg";